import { ContentHeader, Text } from '@croquiscom-pvt/zds';
import { vars } from '@croquiscom-pvt/zds/tokens';
import styled from '@emotion/styled';

import { RecommendOptionValueModel } from '../utils/types';

interface OthersSizeViewProps {
  myFigureText: string;
  recommendOptionValueList: RecommendOptionValueModel[];
  onInfoClick: () => void;
}

export const OthersSizeView = ({ myFigureText, recommendOptionValueList, onInfoClick }: OthersSizeViewProps) => {
  const hasOtherOptions = recommendOptionValueList.length > 0;

  return (
    <Wrapper>
      <ContentHeader title='사이즈 추천' />
      <Subtitle variant='Body_14_Multiline_Regular' color='textTertiary'>
        내 체형({myFigureText}) 구매 정보가 없어요.
      </Subtitle>
      {hasOtherOptions && (
        <ListWrapper>
          <ListHeader variant='Body_15_SemiBold' color='textStrong'>
            다른 체형이 구매한 사이즈
            <TooltipTrigger aria-label='사이즈 추천 안내 버튼' onClick={onInfoClick}></TooltipTrigger>
          </ListHeader>
          <List>
            {recommendOptionValueList.map((item, index) => (
              <OthersSizeOption
                key={item.name + index}
                name={item.name}
                heightRange={item.heightRange}
                weightRange={item.weightRange}
              />
            ))}
          </List>
        </ListWrapper>
      )}
    </Wrapper>
  );
};

interface OthersSizeOptionProps {
  name: string;
  heightRange: { min: number; max: number };
  weightRange: { min: number; max: number };
}

const OthersSizeOption = ({ name, heightRange, weightRange }: OthersSizeOptionProps) => {
  return (
    <OptionItem>
      <OptionName variant='Body_13_Medium' color='textSecondary'>
        {name}
      </OptionName>
      <OptionValue variant='Body_13_Regular' color='textSecondary'>
        {heightRange.min}~{heightRange.max}cm <Dot>·</Dot> {weightRange.min}~{weightRange.max}kg
      </OptionValue>
    </OptionItem>
  );
};

const Wrapper = styled.div`
  background-color: ${vars.color.backgroundSurface};
  padding-bottom: 24px;
`;

const Subtitle = styled(Text)`
  text-align: center;
  margin: 12px 0;
`;

const ListWrapper = styled.div`
  border-radius: 6px;
  background-color: ${vars.color.backgroundOnElevated};
  margin: 0 16px;
`;

const ListHeader = styled(Text)`
  text-align: center;
  padding: 16px;
  border-bottom: 1px solid ${vars.color.dividerThin};
`;

const TooltipTrigger = styled.button`
  display: flex;
  align-items: center;
  margin-left: 4px;
`;

const List = styled.ul`
  padding: 12px 16px 16px 16px;
  gap: 15px;
  display: flex;
  flex-direction: column;
`;

const OptionItem = styled.li`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const OptionName = styled(Text)`
  flex: 1;
`;

const OptionValue = styled(Text)`
  flex-shrink: 0;
`;

const Dot = styled.span`
  margin: 0 4px;
  color: ${vars.v3Color.gray300};
`;
